'use strict';

module.exports = require('./es7-shim').shim();